<template>
  <div class="main-container">

    <div class="container">
      <div class="column-75 page-middle">
        <h2>Please complete the form in the allotted time</h2>
        <br><hr><br>
        <h2><timer></timer></h2>
      </div>
    </div>

                <h1>Upload W9 and affidavit forms</h1>

                <form id="upload_form" class="text-align-center" @submit.prevent="submit_files(local_config.all.methods.post.url)" action="" enctype="multipart/form-data" novalidate>

                    <input class="hidden" name="affidavit_file" type="file" @change="file_uploaded($event,'affidavit_file')" required>
                    <input class="hidden" name="w9_file" type="file" @change="file_uploaded($event,'w9_file')" required>
                    <input name="reward_reservation_uid" type="hidden" :value="$store.state.uid">

                    <div class="clearfix text-upper-case">
                        <div class="upload-file col-mobile-margin-50 margin-vertical-20 font-size-24 cursor-pointer" :class="{'upload-file--invalid': validate && files.affidavit_file == '', 'upload-file--valid': validate && files.affidavit_file  }" @click="upload_file('affidavit_file')">
                            <div class="col-mobile-90 absolut-center" v-if="files.affidavit_file == '' ">Click to upload <br> AFFIDAVIT FORM</div>
                            <div class="col-mobile-90 absolut-center" v-else>{{files.affidavit_file}}</div>
                        </div>
                        <div class="upload-file col-mobile-margin-50 margin-vertical-20 font-size-24 cursor-pointer" :class="{'upload-file--invalid': validate && files.w9_file == '', 'upload-file--valid': validate && files.w9_file != ''  }" @click="upload_file('w9_file')">
                            <div class="col-mobile-90 absolut-center" v-if="files.w9_file == '' ">Click to upload <br> W9 FORM</div>
                            <div class="col-mobile-90 absolut-center" v-else>{{files.w9_file}}</div>
                        </div>
                    </div>

                    <button class="submit-button" type="submit" :disabled="$store.state.loader">SUBMIT</button>

                </form>
            </div>

    </div>

  </div>
</template>

<script>
    import axios from 'axios'
    import $ from 'jquery'

    import {computed_values} from '../mixins/computed_values'
    import {form_methods, requests_methods, validation} from '../mixins/requests'
    import {elements_classes} from '../mixins/elements_classes'

    import Timer from '../components/Timer'

    export default {
        name: "fulfillment_upload_page",
        mixins: [computed_values,form_methods, requests_methods, validation, elements_classes],
        components: {
            'timer': Timer
        },
        data(){
            return{
                // this_page: 'fulfillment_upload_page'
                validate: false,
                files: {
                    w9_file: '',
                    affidavit_file: ''
                }
            }
        },
        computed: {
            this_page(){
                return this.$route.name
            }

        },
        methods: {
            submit_files(url){
                var scope = this;

                this.validate = true;

                if(this.files.w9_file == '' || this.files.affidavit_file == ''){
                    return false
                }

                var formdata = new FormData(document.getElementById('upload_form'))

                axios.post(this.$store.state.API_ROUTE + url,formdata,{headers: {'Content-Type': 'multipart/form-data'}})
                  .then((response) => {
                      this.$store.commit('save_optional_data',{type:'form',data: response.data.data})
                      this.redirect(response.data.redirect_to)
                  })
                  .catch((error)=> {
                      this.show_errors(error)
                      console.log(error)
                  });

            },
            upload_file: function(name){
                $('[name='+name+']').trigger('click')
            },
            file_uploaded: function(e,name){
                if(e.target.files['length'] > 0 ){
                    this.files[name] = e.target.files[0]['name']
                }else{
                    this.files[name] = ''
                }

            }
        }
    }
</script>

<style scoped>
</style>